import useSWR, { SWRResponse } from "swr";
import { Contract } from "../../types";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

interface UseContractsParams {
  enabled?: boolean;
}

const useContracts = ({
  enabled = true,
}: UseContractsParams = {}): SWRResponse<Contract[], Error> => {
  const httpClient: AxiosInstance = useHttpClient();

  return useSWR(
    'contracts',
    enabled
      ? async (): Promise<Contract[]> => {
        const response = await httpClient.get(`/contracts`);
        return response.data.data;
      }
      : null,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );
};

export default useContracts;

